import React from 'react';

import classes from './style.module.scss';

const Divider = () => <div className={classes.Divider} />;

export default Divider;
